import projectTransactionsReportComponent from './project-transactions-report.component';

const projectTransactionsReportModule = angular.module('projectTransactionsReport', [
])
  .component('projectTransactionsReport', projectTransactionsReportComponent)
  .name;

export default projectTransactionsReportModule;
